<template>
    <div>
        <ComponentHeader />
        <main>
            <HeroComponent title="Services" img="servies_Hero_img.png" position="30" pageClass="services" />
            <section class="WorkPlanSection">
                <div class="WorkPlanWrapper MContainer">
                    <div class="WorkPlanBody">
                        <v-expansion-panels dark flat mandatory multiple>
                            <v-expansion-panel :style="{background: '#fff'}" class="mt-2 plansItem"
                                v-for="item in plans" :key="item.text">
                                <v-expansion-panel-header color="#49d6cb" class="rounded mt-2 buttonpanels">
                                    {{item.text}}
                                    <v-spacer></v-spacer>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content color="#fff">
                                    <ServicesViewCompontent :ServicesViewData="dataServicesPlan" />
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </div>
                </div>
            </section>
        </main>
        <FooterCompinent />
    </div>
</template>

<script>
    import ComponentHeader from "@/components/Header.vue";
    import FooterCompinent from "@/components/Footer.vue";
    import ServicesViewCompontent from "@/components/ServicesViewComponet.vue"
    import HeroComponent from "@/components/HeroComonent.vue"
    export default {
        name: "ServicesView",
        components: {
            ComponentHeader,
            FooterCompinent,
            ServicesViewCompontent,
            HeroComponent
        },
        data() {
            return {
                plans: [{
                        text: "Web Development"
                    },
                    {
                        text: "Mobile Development"
                    },
                    {
                        text: "Business Automation"
                    },
                    {
                        text: "UX/UI Design"
                    },
                    {
                        text: "Digital Marketing"
                    }
                ],
                dataServicesPlan: [{
                        img: "@/assets/images/serveis_img_smm.svg",
                        longText: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd",
                        title: "Landing Page",
                        labelText: "Lorem ipsum dolor sit amet, consetet",
                        price: "from 6 000 000",
                        spanText: "* Costs might be different depending on the project"
                    },
                    {
                        img: `@/assets/images/serveis_img_smm.svg`,
                        longText: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd",
                        title: "Landing Page",
                        labelText: "Lorem ipsum dolor sit amet, consetet",
                        price: "from 6 000 000",
                        spanText: "* Costs might be different depending on the project"
                    },
                    {
                        img: "@/assets/images/serveis_img_smm.svg",
                        longText: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd",
                        title: "Landing Page",
                        labelText: "Lorem ipsum dolor sit amet, consetet",
                        price: "from 6 000 000",
                        spanText: "* Costs might be different depending on the project"
                    },
                    {
                        img: "@/assets/images/serveis_img_smm.svg",
                        longText: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd",
                        title: "Landing Page",
                        labelText: "Lorem ipsum dolor sit amet, consetet",
                        price: "from 6 000 000",
                        spanText: "* Costs might be different depending on the project"
                    },
                    {
                        img: "@/assets/images/serveis_img_smm.svg",
                        longText: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd",
                        title: "Landing Page",
                        labelText: "Lorem ipsum dolor sit amet, consetet",
                        price: "from 6 000 000",
                        spanText: "* Costs might be different depending on the project"
                    },
                    {
                        img: "@/assets/images/serveis_img_smm.svg",
                        longText: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd",
                        title: "Landing Page",
                        labelText: "Lorem ipsum dolor sit amet, consetet",
                        price: "from 6 000 000",
                        spanText: "* Costs might be different depending on the project"
                    }
                ]
            }
        }
    }
</script>

<style lang="scss" scoped>
    .WorkPlanSection {
        margin-top: 95px;
        .WorkPlanWrapper {
            .buttonpanels {
                padding: 20px;
                width: 1366px !important;
                margin: 0 auto;
                margin-left: 25px;
                font-weight: bold;
                border-radius: 15px!important;
                font-size: 24px;
                padding-left: 32px;
            }
        }
    }

    .plansItem {
        display: block;
        margin: 3.9px;

        button {
            border-radius: 10px !important;
            color: #fff;

            div {
                i {
                    color: #fff !important;
                }
            }
        }
    }

    .mdi-chevron-down {
        color: #fff !important;
    }

    @media only screen and (max-width: 1500px) {
        .WorkPlanSection {
            margin-top: 95px;

            .WorkPlanWrapper {
                .buttonpanels {
                    padding: 20px;
                    margin: 5px;
                    width: 1300px !important;
                    margin: 0 auto;
                    font-weight: bold;
                    font-size: 24px;
                    padding-left: 37px;
                }
            }
        }

    }

    @media only screen and (max-width: 1370px) {
        .WorkPlanSection {
            margin-top: 95px;

            .WorkPlanWrapper {
                .buttonpanels {
                    padding: 20px;
                    margin: 5px;
                    width: 1180px !important;
                    margin: 0 auto;
                    font-weight: bold;
                    font-size: 24px;
                    padding-left: 37px;
                }
            }
        }

    }

    @media only screen and (max-width: 1215px) {
        .WorkPlanSection {
            margin-top: 95px;

            .WorkPlanWrapper {
                .buttonpanels {
                    padding: 20px;
                    margin: 5px;
                    width: 1000px !important;
                    margin: 0 auto;
                    font-weight: bold;
                    font-size: 24px;
                    padding-left: 37px;
                }
            }
        }
    }

    @media only screen and (max-width: 1035px) {
        .WorkPlanSection {
            margin-top: 95px;

            .WorkPlanWrapper {
                .buttonpanels {
                    padding: 20px;
                    margin: 5px;
                    width: 100% !important;
                    margin: 0 auto;
                    font-weight: bold;
                    font-size: 24px;
                    padding-left: 37px;
                }
            }
        }
    }

</style>